import CompletedOperations from '@domains/completed-operations/views/CompletedOperations.vue'

export default [
  {
    path: 'completed-operations',
    component: CompletedOperations,
    name: 'CompletedOperations',
    props: (route) => ({
      search: route.query.search,
      type: route.query.type,
      closedAt: route.query.closedAt,
      id: route.query.id
    })
  }
]
